import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CheckService } from 'src/app/checks/check.service';
import { allowedDomainValidator } from 'src/app/validators/custom-validators';
import { FormMessage } from 'src/app/ui-design-library/form-message/form-message.model';
import { Approval } from '../approval.model';
import { ApprovalService } from '../approval.service';
import { asyncCheckEmailForAllowedDomain, asyncEmailValidator } from 'src/app/validators/email-validators';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { FormMessageComponent } from 'src/app/ui-design-library/form-message/form-message.component';
import { NgClass } from '@angular/common';
import { ShowErrorComponent } from 'src/app/ui-design-library/forms/show-error/show-error.component';

@Component({
  selector: 'fnsr-approval-create-form',
  standalone: true,
  imports: [IconComponent, ReactiveFormsModule, FormMessageComponent, NgClass, ShowErrorComponent],
  templateUrl: './approval-create-form.component.html',
  styleUrls: ['./approval-create-form.component.scss']
})
export class ApprovalCreateFormComponent implements OnInit {
  form!: FormGroup;
  isLoading = false;
  buttonText = 'Freigeben';
  isValidatingEmail = false;
  formMessage?: FormMessage;

  constructor(
    public fb: FormBuilder,
    public router: Router,
    public checkService: CheckService,
    public approvalService: ApprovalService,
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    this.form = this.fb.group({
      email: new FormControl('', {
        validators: [
          Validators.required,
          // barmeniaEmailValidator,
          allowedDomainValidator
        ],
        asyncValidators: [
          asyncEmailValidator(this.checkService),
          asyncCheckEmailForAllowedDomain(this.checkService)
        ],
        updateOn: 'blur'
      })
    });
  }

  onSubmit(approval: Approval): void {
    this.isLoading = true;
    this.buttonText = 'Sende...';

    this.approvalService.createApproval(approval).subscribe(
      result => {
        this.isLoading = false;

        this.formMessage = {
          message: `Freigabe für ${result.email} angelegt.`,
          messageType: 'success'
        };
        this.buttonText = 'Freigegeben';
      },
      (err: Error) => {
        console.log(err);
        this.isLoading = false;
        this.buttonText = 'Freigeben';

        this.formMessage = {
          message: err.message,
          messageType: 'error'
        };
      }
    );
  }

  resetForm() {
    this.isLoading = false;
    this.buttonText = 'Freigeben';
    delete this.formMessage;
    this.form?.reset();
  }
}